function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("g", {
  clipPath: "url(#clip0_2835_476)"
}, React.createElement("g", {
  clipPath: "url(#clip1_2835_476)"
}, React.createElement("path", {
  d: "M12.7075 13.0709C11.4967 13.9939 10.0223 14.5052 8.50004 14.5301C3.54171 14.5301 0.708374 8.86344 0.708374 8.86344C1.58946 7.22145 2.81151 5.78687 4.29254 4.65594M7.01254 3.36678C7.50011 3.25265 7.99929 3.1956 8.50004 3.19678C13.4584 3.19678 16.2917 8.86344 16.2917 8.86344C15.8617 9.66783 15.349 10.4251 14.7617 11.123M10.0017 10.3651C9.80716 10.5739 9.57256 10.7413 9.3119 10.8575C9.05123 10.9736 8.76985 11.0361 8.48452 11.0411C8.1992 11.0462 7.91578 10.9937 7.65118 10.8868C7.38658 10.7799 7.14622 10.6208 6.94443 10.4191C6.74265 10.2173 6.58357 9.9769 6.47669 9.7123C6.36982 9.4477 6.31733 9.16429 6.32236 8.87896C6.3274 8.59364 6.38985 8.31225 6.50599 8.05159C6.62214 7.79092 6.78959 7.55632 6.99837 7.36178M0.708374 1.07178L16.2917 16.6551",
  stroke: "#0F172A",
  strokeWidth: 1.41667,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})));

var _ref3 =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("clipPath", {
  id: "clip0_2835_476"
}, React.createElement("rect", {
  width: 17,
  height: 17,
  fill: "white",
  transform: "translate(0 0.363525)"
})), React.createElement("clipPath", {
  id: "clip1_2835_476"
}, React.createElement("rect", {
  width: 17,
  height: 17,
  fill: "white",
  transform: "translate(0 0.363525)"
})));

var SvgHidePassword = function SvgHidePassword(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    ref: svgRef
  }, props), _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgHidePassword, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/HidePassword.cae7a08b.svg";
export { ForwardRef as ReactComponent };